export const generateDaysOfYear = () => {
  const days = [];

  // Only add days from November and December of the previous year
  const prevYear = new Date(new Date().getFullYear() - 1, 10, 1); // November 1st previous year
  const endPrevYear = new Date(new Date().getFullYear(), 0, 1); // January 1st current year

  while (prevYear < endPrevYear) {
    const day = String(prevYear.getDate()).padStart(2, "0");
    const month = String(prevYear.getMonth() + 1).padStart(2, "0"); // JS months are 0-based

    const dateForBack = `${prevYear.getFullYear()}-${month}-${day}`;

    days.push({
      date: `${day}.${month}.${prevYear.getFullYear()}`,
      dayName: prevYear.toLocaleDateString("en-GB", { weekday: "short" }),
      isWeekend: [0, 6].includes(prevYear.getDay()),
      isToday: false,
      dateForBack,
    });

    prevYear.setDate(prevYear.getDate() + 1);
  }

  const currentDate = new Date(new Date().getFullYear(), 0, 1);
  const year = currentDate.getFullYear();
  const today = new Date();

  while (currentDate.getFullYear() === year) {
    const day = String(currentDate.getDate()).padStart(2, "0");
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const isToday = currentDate.toDateString() === today.toDateString();

    const dateForBack = `${currentDate.getFullYear()}-${month}-${day}`;

    days.push({
      date: `${day}.${month}`,
      dayName: currentDate.toLocaleDateString("en-GB", { weekday: "short" }),
      isWeekend: [0, 6].includes(currentDate.getDay()),
      isToday,
      dateForBack,
    });

    currentDate.setDate(currentDate.getDate() + 1);
  }

  const daysOfNextYear = [];
  const currentDateNextYear = new Date(new Date().getFullYear() + 1, 0, 1);
  const yearNextYear = currentDateNextYear.getFullYear();

  while (currentDateNextYear.getFullYear() === yearNextYear) {
    const day = String(currentDateNextYear.getDate()).padStart(2, "0");
    const month = String(currentDateNextYear.getMonth() + 1).padStart(2, "0");

    const dateForBack = `${currentDateNextYear.getFullYear()}-${month}-${day}`;

    daysOfNextYear.push({
      date: `${day}.${month}.${(currentDateNextYear.getFullYear())}`,
      dayName: currentDateNextYear.toLocaleDateString("en-GB", {
        weekday: "short",
      }),
      isWeekend: [0, 6].includes(currentDateNextYear.getDay()),
      today: false,
      dateForBack,
    });

    currentDateNextYear.setDate(currentDateNextYear.getDate() + 1);
  }

  return [...days, ...daysOfNextYear];
};
